import { queryClient } from "lib/query-client";
import useFeaturesState from "~/stores/feature";
import useSettingState from "~/stores/setting";
import useUiDashboardTreeState from "~/stores/ui/dashboard-tree";
import useUiNodeState from "~/stores/ui/node";
import useUserState from "~/stores/user";

/**
 * Drops every trace of the signed-in user from the persisted stores.
 *
 * Shared by the Logout button and by the root route's guard, which signs a user out when
 * they may not see the home page. Enumerating the stores in one place is the point: they
 * persist to localStorage, so a store missed here keeps one user's filters, expansion
 * state or company settings visible to whoever logs in next on the same browser.
 */
export function clearSession() {
  useUserState.getState().reset();
  useSettingState.getState().reset();
  useUiNodeState.getState().reset();
  useUiDashboardTreeState.getState().reset();
  useFeaturesState.getState().reset();

  // The cache outlives a logout on its own: the client is module-scoped and logging out
  // navigates rather than reloading, so without this the next user to sign in on this tab
  // is served the previous one's company data for as long as it stays fresh.
  queryClient.clear();
}
